import { makeStyles } from '@material-ui/core';
import * as React from 'react';

const useStyles = makeStyles({ root: { flexGrow: 1 } }, { name: 'Glue' });

export const Glue = () => <div className={useStyles().root} />;
